import { Request } from '../../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../../httpClient/serverApi/types/IResponse';
import { IDashExtSiteSettings } from '../../../../types/ISiteSettingsForSiteAdmin';

export interface IUpdateDashExtSiteSettingsParams {
  siteSettings: IDashExtSiteSettings;
}

export type IUpdateExtensionsSiteSettingsResult = IResult & IDashExtSiteSettings;

export class UpdateExtensionsSiteSettingsRequest extends Request<IUpdateDashExtSiteSettingsParams, IUpdateExtensionsSiteSettingsResult> {
  constructor(params: IUpdateDashExtSiteSettingsParams) {
    super('updateExtensionsSiteSettings', params);
  }
}
